module.exports = __webpack_public_path__ + "img/barcode.d9567e70.png";